module.exports = __webpack_public_path__ + "img/image-023.e7c3a2ab.png";